import React, { useState } from 'react';
import { IonPage, IonContent, IonHeader, IonToolbar, IonTitle, IonButton, IonInput, IonItem, IonLabel, IonTextarea, IonAlert, IonCard, IonText } from '@ionic/react';
import { _defaultButtonColor, _dict } from '../components/constants';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { submitFeedback } from '../foo/firedb';

const FeedbackForm: React.FC = () => {
  const [feedback, setFeedback] = useState('');
  const [showEmailPrompt, setShowEmailPrompt] = useState(false);
  const [showThanksMsg, setShowThanksMsg] = useState(false);
  const {lang} = useGlobalStore();

  const handleFeedbackSubmit = () => {
    // Prompt for email after feedback is submitted
    setShowEmailPrompt(true);
  };

  const handleFinalSubmit = async (email: string, feedback:string) => {
    await submitFeedback(email, feedback);
    // Here you would connect to Firebase or another backend to store the feedback and email
    // Reset form fields
    setShowEmailPrompt(false);
    setShowThanksMsg(true);
  };

  if (showThanksMsg === false) {
  return (
    <div>

       <IonItem>
        <IonLabel position="floating">{_dict.writeHere[lang]}</IonLabel>
        <IonTextarea value={feedback} onIonInput={e => setFeedback(e.detail.value!)} required></IonTextarea>
      </IonItem>
      <IonButton
      expand="block"
      onClick={handleFeedbackSubmit}
      disabled={!feedback.trim()}
      style={{ "--background": _defaultButtonColor }}
      >
        {_dict.send[lang]}
    </IonButton>

      <IonAlert
        isOpen={showEmailPrompt}
        onDidDismiss={() => setShowEmailPrompt(false)}
        subHeader={_dict.doYouWantToStayInformedPerEmail[lang]}
        inputs={[
          {
            name: 'email',
            type: 'email',
            placeholder: 'your@email.com'
          }
        ]}
        buttons={[
          {
            text: _dict.noThanks[lang],
            role: 'cancel',
            cssClass: 'secondary',
            handler: (alertData) => {
                handleFinalSubmit("no-email", feedback);
            }
          },
          {
            text: _dict.ok[lang],
            handler: (alertData) => {
              handleFinalSubmit(alertData.email, feedback);
            }
          }
        ]}
      />
    </div>
  );
    } else {
        return (
            <div style={{textAlign:"center"}}>
                <div style={{backgroundColor:"white", width:"auto", padding:"10px"}}>
                    <IonText color="dark" >
                        {_dict.thanksForYourContribution[lang]}
                    </IonText>
                </div>
            </div>

        );
        }
};

export default FeedbackForm;
